import * as Dialog from '@radix-ui/react-dialog';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

/**
 * «Rifiutare NS…?»: the yes/no confirmation of «Rifiuta la nota», a centred dialog (board #667);
 * side sheets stay for pickers and forms.
 */
export function RefuseDialog({
  number,
  busy,
  onConfirm,
  onClose,
}: {
  readonly number: string;
  readonly busy: boolean;
  readonly onConfirm: () => void;
  readonly onClose: () => void;
}) {
  const { t } = useTranslation('expenses');
  return (
    <Dialog.Root open onOpenChange={(next) => (next ? undefined : onClose())}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-[var(--scrim)]" />
        <Dialog.Content className="border-border bg-card fixed top-1/2 left-1/2 z-50 grid w-[min(26rem,calc(100vw-2rem))] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl border p-6 shadow-lg">
          <Dialog.Title className="text-foreground text-lg font-semibold">
            {t('reports.page.decision.refuseTitle', { number })}
          </Dialog.Title>
          <Dialog.Description className="text-muted-foreground text-sm">
            {t('reports.page.decision.refuseAsk')}
          </Dialog.Description>
          <div className="flex flex-wrap justify-end gap-2">
            <Button type="button" variant="outline" onClick={onClose}>
              {t('reports.page.decision.cancel')}
            </Button>
            <Button type="button" variant="destructive" disabled={busy} onClick={onConfirm}>
              {t('reports.page.decision.refuse')}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
